import type { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { LogoSVG } from '@/components/app/logo';

function Footer() {
	const { t } = useTranslation();
	return (
		<footer className="w-full bg-ash-50">
			<div className="mx-auto w-full max-w-screen-sm bg-ash-50">
				<div className="flex justify-between px-4 py-5">
					<div className="">
						<LogoSVG className="h-6 fill-ash-800" />
					</div>
					<div className="flex justify-between gap-x-6">
						<SocialLink url="https://www.youtube.com/@az3fr" target="_blank">
							<span className="icon-[tabler--brand-youtube-filled] bg-ash-800 text-3xl transition-colors duration-150 hover:bg-red-500" />
						</SocialLink>
						<SocialLink url="https://www.instagram.com/az3fr" target="_blank">
							<span className="icon-[tabler--brand-instagram-filled] bg-ash-800 from-[#feda75] via-[#d62976] to-[#4f5bd5] text-3xl hover:bg-gradient-to-tr" />
						</SocialLink>
						<SocialLink url="https://www.twitter.com/az3fr" target="_blank">
							<span className="icon-[tabler--brand-twitter-filled] bg-ash-800 text-3xl transition-colors duration-150 hover:bg-sky-500" />
						</SocialLink>
					</div>
				</div>
				<p className="border-ash-300 border-t px-4 py-2 text-xs">
					{t('layout.footer.copyright', { year: new Date().getFullYear() })}
				</p>
			</div>
		</footer>
	);
}

function SocialLink({
	children,
	url,
	...props
}: {
	children: React.ReactNode;
	url: string;
} & React.ComponentProps<typeof Link>) {
	return (
		<a href={url} {...props}>
			{children}
		</a>
	);
}

export { Footer };
